import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationStore } from '../../../permission/services/authentication.store';
import { FormBuilder, FormGroup } from '@angular/forms';
import { OnyxEvent } from '../../models/event';
import { PioneerValidators } from '../../../shared/utils/pioneer.validators';
import { PaymentStore } from '../../service/payment.store';
import { LogService } from '../../../shared/log/log.service';
import { Payment } from '../../models/payment';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { Party } from '../../models/party';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { Subject } from 'rxjs/Subject';
import { PioneerUtils } from 'app/event/utils/pioneer-utils';

@Component({
  selector: 'pioneer-forecasted-commission',
  templateUrl: './forecasted-commission.component.html',
  styleUrls: ['./forecasted-commission.component.css']
})
export class ForecastedCommissionComponent implements OnInit, OnDestroy {

  onyxEvent: OnyxEvent;
  forecastedCommissionForm: FormGroup;
  forecastedCommAmount: string;
  currentPayment: Payment;

  @Input()
  vendor: Party;

  private _destroy$: Subject<boolean> = new Subject<boolean>();

  @Input()
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  constructor(
    private authenticationStore: AuthenticationStore,
    private formBuilder: FormBuilder,
    private paymentStore: PaymentStore,
    private logService: LogService,
    private flashMessagesService: FlashMessagesService) { }

  ngOnInit() {
    this.subscribeForecastedCommAmount();
  }

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }

  isMultiVendor() {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

  showForecastedCommissionForm(): boolean {
    if (!this.authenticationStore.hasPermission('PayCommission') && !this.authenticationStore.isSupportUser()) {
      return false;
    }
    if (this.isMultiVendor()) {
      return true;
    }
    if (this.forecastedCommAmount && parseFloat(this.forecastedCommAmount) > 0) {
      return true;
    }
    return  false;
  }

  onFocusOutForecastedCommission(event: any) {
    try {
      let newValue;
      if (event.target.value === '') {
        newValue = null;
      } else {
        newValue = parseFloat(event.target.value);
        if (Number.isNaN(newValue)) {
          return;
        }
      }

      newValue = PioneerUtils.addTrailingZeros(newValue);
      this.forecastedCommissionForm.controls['forecastedCommissionAmount'].setValue(newValue);

      this.logService.debug(`Request for change of forecastedCommAmount -> current: ${this.forecastedCommAmount}, new: ${newValue}`);

      if (this.isMultiVendor() && this.forecastedCommissionForm.valid && this.forecastedCommAmount !== newValue) {
        this.logService.info(`Saving new forecasted commission amount value: ${newValue}`);

        const payment = new Payment({
          eventPaymentId: this.currentPayment.eventPaymentId,
          commissionCurrency: this.onyxEvent.currency,
          eventId: this.currentPayment.eventId,
          eventPartyId: this.currentPayment.eventPartyId,
          forecastedCommissionAmount: newValue
        });
        const obs$ = this.updateForecastedCommissionAmount(payment);
        obs$.pipe(takeUntil(this._destroy$)).subscribe();
     }
    } catch (error) {
      this.logService.error(`Error saving new forecasted commission amount value: ${error}`);
      this.flashMessagesService.error('MESSAGES.ERROR.UPDATE_FORECASTED_COMMISSION_AMOUNT');
    }
  }

  private updateForecastedCommissionAmount(payment: Payment): Observable<any> {
    return this.paymentStore.updateForecastedCommissionAmount(payment).pipe(
      tap(() => {
        const eventId = this.onyxEvent.eventId;
        this.paymentStore.loadLatestFinalPayment(eventId).pipe(takeUntil(this._destroy$)).subscribe();
        this.paymentStore.loadLatestInitialPayments(eventId).pipe(takeUntil(this._destroy$)).subscribe();
      }),
      catchError((error) => {
        this.logService.error(`Error saving new forecasted commission amount value: ${error}`);
        return Observable.of(error);
      })
    );
  }

  private subscribeForecastedCommAmount(): void {
    this.paymentStore.getCurrentPayment(this.vendor.eventPartyId).pipe(
      takeUntil(this._destroy$)
    ).subscribe((currentPayment: Payment) => {
      this.currentPayment = currentPayment;
      this.forecastedCommAmount = PioneerUtils.addTrailingZeros(currentPayment ? currentPayment.forecastedCommissionAmount : 0.0);
      this.forecastedCommissionForm = this.formBuilder.group({
        'forecastedCommissionAmount': [this.forecastedCommAmount, [PioneerValidators.isValidAmountInRange(0.01, 99999999.99)]]
      });
    });

  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/forecasted-commission/forecasted-commission.component.ts